export enum UsersSortType {
  NONE = 'NONE',
  ASCENDING = 'ASC',
  DESCENDING = 'DESC',
}

export interface UsersFilter {
  searchTerm?: string
  sortBy?: string,
  sortDirection?: UsersSortType
}
